import React from "react";

function VerifiedProfile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18.006"
      viewBox="0 0 18 18.006"
    >
      <path
        id="Path_21842"
        data-name="Path 21842"
        d="M19.606,9.865,18.382,8.443a2,2,0,0,1-.423-1.134V5.779a1.744,1.744,0,0,0-1.737-1.737h-1.53a2.019,2.019,0,0,1-1.134-.423L12.136,2.394a1.814,1.814,0,0,0-2.268,0L8.455,3.627a2.076,2.076,0,0,1-1.134.414H5.764A1.744,1.744,0,0,0,4.026,5.779V7.318a2.048,2.048,0,0,1-.414,1.125L2.4,9.874a1.812,1.812,0,0,0,0,2.25l1.215,1.431a2.048,2.048,0,0,1,.414,1.125v1.539a1.744,1.744,0,0,0,1.737,1.737H7.321a2.019,2.019,0,0,1,1.134.423L9.877,19.6a1.814,1.814,0,0,0,2.268,0l1.422-1.224a2,2,0,0,1,1.134-.423h1.53a1.744,1.744,0,0,0,1.737-1.737v-1.53a2.019,2.019,0,0,1,.423-1.134l1.224-1.422a1.826,1.826,0,0,0-.009-2.268ZM14.746,9.3,10.4,13.645a.674.674,0,0,1-.954,0L7.267,11.467a.675.675,0,0,1,.954-.954l1.7,1.7,3.87-3.87a.675.675,0,0,1,.954.954Z"
        transform="translate(-2.006 -1.996)"
        fill="#03f"
      />
    </svg>
  );
}

export default VerifiedProfile;
